function formatCatalogModuleTree(tree = []) {
  if (!tree.length) {
    return '(nenhum módulo vinculado a este produto)';
  }

  const lines = [];

  tree.forEach((category) => {
    lines.push(`- Categoria: ${category.title || '(sem título)'}`);
    (category.cards || []).forEach((card) => {
      lines.push(`  - Módulo: ${card.title || '(sem título)'}`);
    });
  });

  return lines.join('\n');
}

/**
 * Prompt + estrutura do produto para colar em IA externa e sugerir filtros da vitrine.
 */
export function buildProductCatalogAiAssistantText(tree = [], { productName } = {}) {
  const productLine = productName ? `Produto: ${productName}\n\n` : '';
  const moduleTree = formatCatalogModuleTree(tree);

  return `${productLine}Tenho um produto na vitrine do meu app com estes módulos:

${moduleTree}

Sugira filtros para a vitrine deste produto.

Como pensar nos filtros:
- Crie nomes de filtro pensando em como o ALUNO busca conteúdo (tema, tipo, intenção) — podem ser criativos e NÃO precisam repetir as categorias administrativas
- Interprete os títulos dos módulos para agrupar por tema, mesmo quando estão em categorias diferentes
- Prefira poucos filtros enxutos; um módulo pode entrar em mais de um filtro, ou não entrar em nenhum (visível apenas quando nenhum filtro está selecionado)

Regras:
- Não inclua o filtro "Todos" — ele já existe na vitrine quando nenhum filtro está selecionado
- Nomes de filtro: até 3 palavras, sem caracteres especiais
- Evite filtros por mês ou data (o catálogo cresce e a barra fica enorme)
- Ao LISTAR o que entra em cada filtro, use somente categorias e módulos da lista acima, com título COPIADO LITERALMENTE — não invente itens inexistentes
- Em cada linha de módulo, informe a categoria pai (título literal da lista)

Formato da resposta (obrigatório, em português). Use estes rótulos e a estrutura; preencha com os dados reais da lista:

1) Para cada filtro sugerido:

Filtro: …
- Categoria: … (todos os módulos)
- Módulo: … — Categoria: …

(use "Categoria … (todos os módulos)" quando a categoria inteira entrar; senão liste módulo a módulo com a categoria pai)

2) Não aplicado em nenhum filtro, aparece quando nenhum filtro é selecionado:

- Módulo: … — Categoria: …
(ou "Nenhum")

3) Filtros da Vitrine deste produto:

… · … · …
(apenas os nomes dos filtros sugeridos acima)

4) Observações (opcional):

…

Resumo: nomes dos filtros = livres e orientados ao aluno; títulos de categorias e módulos na resposta = exatos da lista, com categoria em toda linha de módulo, para o admin marcar nos checkboxes do painel.`;
}

export { formatCatalogModuleTree };

export async function copyTextToClipboard(text) {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return true;
  }

  if (typeof document !== 'undefined') {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  }

  return false;
}
